import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/quick-reply.vue
var o = {
	name: "DtIconQuickReply",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--quick-reply"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Quick Reply",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M10 8.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 1 0-1h5A1.5 1.5 0 0 1 11 3.5v5A1.5 1.5 0 0 1 9.5 10H3.707l-1.853 1.854A.5.5 0 0 1 1 11.5V9a.5.5 0 1 1 1 0v1.293l1.147-1.146.076-.063A.5.5 0 0 1 3.5 9h6a.5.5 0 0 0 .5-.5ZM2.071 1.743a.5.5 0 0 1 .858.514L1.883 4H3a.501.501 0 0 1 .429.757l-1.5 2.5a.5.5 0 0 1-.858-.514L2.117 5H1a.5.5 0 0 1-.429-.757l1.5-2.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=quick-reply.js.map